import { useState, useEffect } from "react";

// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  TextField,
  FormControl,
  FormHelperText,
  Select,
  MenuItem,
  InputLabel,
  Checkbox,
  Autocomplete,
} from "@mui/material";
import { styled } from "@mui/system";
import EditNoteIcon from "@mui/icons-material/EditNote";

// InterFace
import { EditDataDifine } from "../config/dataInterface";
import { LIST_POST } from "../config/const";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../lib/store";
import { useWindowSize } from "../lib/useWindowSize";

interface DataEditModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  editData: EditDataDifine | null;
  setEditData: (data: EditDataDifine | null) => void;
  putEditData: () => void;
  groupList: {
    group_id: number;
    group_name: string;
  }[];
  categoryList: { id: number; category_name: string }[];
  accountCollaborateCompanySaleList: {
    sale_company_id: number;
    sale_company_name: string;
    id: number;
    account_name: string;
  }[];
  selectServiseInfo: {
    service_plan_data: { service_name: string }[];
    service_content_data: { service_name: string }[];
    service_campaign_pulldown_data: { service_name: string }[];
    service_campaign_checkbox_data: { service_name: string }[];
  };
  selectTossUpInfo: {
    tossUpCategoryNameList: {
      category_id: number;
      category_name: string;
    }[];
    tossUpProductNameList: {
      category_id: number;
      category_name: string;
      product_name: string;
    }[];
  };
  /** 編集用の選択肢リスト（editType==="list" で渡した場合、このリストで表示・選択） */
  optionListForEdit?: { id: number; name: string }[];
}
const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    height: "12px", // ここでフォントサイズを指定
  },
});
CustomTextField.defaultProps = {
  autoComplete: "off",
};

export function DataEditModal(props: DataEditModalProps) {
  const {
    onModal,
    swCloseModal,
    editData,
    setEditData,
    putEditData,
    groupList,
    categoryList,
    accountCollaborateCompanySaleList,
    selectServiseInfo,
    selectTossUpInfo,
    optionListForEdit,
  } = props;
  const { windowWidth, windowHeight } = useWindowSize();
  const loginUser = useAtomValue(AppAtoms.loginUser);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: windowWidth > 568 ? "500px" : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const [autocompleteInputList, setAutocompleteInputList] = useState<string[]>(
    [],
  );
  const [autocompleteInput, setAutocompleteInput] = useState<string>("");
  useEffect(() => {
    let autocompleteInputList: string[] = [];
    if (editData && editData.editType === "list") {
      if (editData.key === "category_name") {
        autocompleteInputList = categoryList.map((input) => {
          return input.category_name;
        });
      } else if (editData.key === "sale_company_group_id") {
        autocompleteInputList = groupList.map((input) => {
          return input.group_name;
        });
      } else if (editData.key === "authority") {
        autocompleteInputList = LIST_POST["edit_authority"].map((input) => {
          return input.value;
        });
      } else if (
        editData.key === "sale_account_name" ||
        editData.key === "toss_up_account_name" ||
        editData.key === "closer_account_name"
      ) {
        autocompleteInputList = accountCollaborateCompanySaleList.map(
          (input) => {
            return input.sale_company_name + " / " + input.account_name;
          },
        );
      } else if (optionListForEdit && optionListForEdit.length > 0) {
        autocompleteInputList = optionListForEdit.map((input) => input.name);
        const found = optionListForEdit.find(
          (o) => String(o.id) === String(editData.editValue)
        );
        if (found) setAutocompleteInput(found.name);
        else setAutocompleteInput("");
      } else {
        autocompleteInputList = LIST_POST[editData.key].map((input) => {
          return input.value;
        });
      }
    } else {
      setAutocompleteInput("");
    }
    setAutocompleteInputList(autocompleteInputList);
  }, [editData, optionListForEdit]);

  useEffect(() => {
    if (editData) {
      let editValue = editData.editValue;
      if (editData.editValue !== undefined && editData.editValue !== null) {
        if (editData.key === "category_name") {
          categoryList.map((input) => {
            if (autocompleteInput === input.category_name) {
              editValue = String(input.id);
            }
          });
        } else if (editData.key === "sale_company_group_id") {
          groupList.map((input) => {
            if (autocompleteInput === input.group_name) {
              editValue = String(input.group_id);
            }
          });
        } else if (editData.key === "authority") {
          LIST_POST["edit_authority"].map((input) => {
            if (autocompleteInput === input.value) {
              editValue = String(input.id);
            }
          });
        } else if (
          editData.key === "sale_account_name" ||
          editData.key === "toss_up_account_name" ||
          editData.key === "closer_account_name"
        ) {
          accountCollaborateCompanySaleList.map((input) => {
            if (
              autocompleteInput ===
              input.sale_company_name + " / " + input.account_name
            ) {
              editValue = String(input.id);
            }
          });
        } else if (optionListForEdit && optionListForEdit.length > 0) {
          optionListForEdit.forEach((input) => {
            if (input.name === autocompleteInput) {
              editValue = String(input.id);
            }
          });
        } else {
          LIST_POST[editData.key].map((input) => {
            if (autocompleteInput === input.value) {
              editValue = String(input.id);
            }
          });
        }
        setEditData({
          ...editData,
          editValue: editValue,
        });
      } else {
        setEditData({
          ...editData,
          editValue: "",
        });
      }
    }
  }, [autocompleteInput]);

  return editData ? (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      data-testid="data-edit-modal"
    >
      <Box sx={style}>
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
          }}
          key="serchTitleBox"
          className="shippori-antique-regular"
        >
          編集 - {editData.name}
        </Box>
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
          {editData.status === "before" ? (
            <>
              {editData.editType === "entry_info" ? (
                <Box
                  key="shozai1"
                  sx={{
                    maxHeight:
                      windowWidth > 385 ? "calc(70vh - 100px)" : undefined,
                    overflowY: windowWidth > 385 ? "auto" : undefined,
                  }}
                >
                  <Box className="serch-label">プラン</Box>
                  <Box key="servicePlanBox">
                    <FormControl
                      fullWidth
                      sx={{
                        marginTop: "10px",
                        marginBottom: "20px",
                        marginLeft: "5px",
                        width: "calc(100% - 10px)",
                      }}
                    >
                      <Select
                        labelId="serch-input-label"
                        id="serch-input-option"
                        key={"servicePlanSelect"}
                        value={
                          (editData.editValue as { [key: string]: string })
                            .servicePlanName
                        }
                        onChange={(e) => {
                          const servicePlanName = e.target.value as string;
                          let editValue = editData.editValue as {
                            [key: string]: string | string[];
                          };
                          editValue["servicePlanName"] = servicePlanName;
                          setEditData({
                            ...editData,
                            editValue,
                          });
                        }}
                        sx={{
                          height: "30px",
                          textAlign: "end",
                          fontSize: "14px",
                        }}
                      >
                        {selectServiseInfo.service_plan_data.map(
                          (service, plan_i) => {
                            return (
                              <MenuItem
                                key={"tableColumnKomokuPlan" + plan_i}
                                value={service.service_name}
                                sx={{
                                  fontSize: "14px",
                                  height:
                                    service.service_name === ""
                                      ? "14px"
                                      : "24px",
                                  minHeight: "auto",
                                }}
                              >
                                {service.service_name}
                              </MenuItem>
                            );
                          },
                        )}
                      </Select>
                    </FormControl>
                  </Box>
                  {selectServiseInfo.service_content_data.length > 0 ? (
                    <Box key="contractServiceContent">
                      <Box className="serch-label">コンテンツ</Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          marginTop: "10px",
                          marginBottom: "20px",
                          marginLeft: "5px",
                          width: "calc(100% - 10px)",
                        }}
                      >
                        {selectServiseInfo.service_content_data.map(
                          (service) => {
                            return (
                              <Box
                                className="serch-label"
                                sx={{ marginRight: "25px" }}
                              >
                                <Checkbox
                                  checked={
                                    (
                                      editData.editValue as {
                                        [key: string]: string[];
                                      }
                                    ).serviceContentNameList.findIndex(
                                      (serviceName) =>
                                        serviceName === service.service_name,
                                    ) > -1
                                  }
                                  onClick={() => {
                                    let serviceContentNameList = (
                                      editData.editValue as {
                                        [key: string]: string[];
                                      }
                                    ).serviceContentNameList.concat();

                                    if (
                                      (
                                        editData.editValue as {
                                          [key: string]: string[];
                                        }
                                      ).serviceContentNameList.findIndex(
                                        (serviceName) =>
                                          serviceName === service.service_name,
                                      ) > -1
                                    ) {
                                      serviceContentNameList =
                                        serviceContentNameList.filter(
                                          (serviceName) =>
                                            serviceName !==
                                            service.service_name,
                                        );
                                    } else {
                                      serviceContentNameList.push(
                                        service.service_name,
                                      );
                                    }
                                    let editValue = editData.editValue as {
                                      [key: string]: string | string[];
                                    };
                                    editValue["serviceContentNameList"] =
                                      serviceContentNameList;
                                    setEditData({
                                      ...editData,
                                      editValue,
                                    });
                                  }}
                                  sx={{
                                    "& .MuiSvgIcon-root": { fontSize: 16 },
                                    marginTop: "-5px",
                                  }}
                                />
                                {service.service_name}
                              </Box>
                            );
                          },
                        )}
                      </Box>
                    </Box>
                  ) : null}
                  {selectServiseInfo.service_campaign_pulldown_data.length >
                  0 ? (
                    <Box key="serviceeCampaignPulldownLabelBox">
                      <Box className="serch-label">
                        {selectServiseInfo.service_campaign_checkbox_data
                          .length > 0
                          ? "キャンペーン1"
                          : "キャンペーン"}
                      </Box>
                      <Box key="serviceeCampaignPulldownBox">
                        <FormControl
                          fullWidth
                          sx={{
                            marginTop: "10px",
                            marginBottom: "20px",
                            marginLeft: "5px",
                            width: "calc(100% - 10px)",
                          }}
                        >
                          <Select
                            labelId="serch-input-label"
                            id="serch-input-option"
                            key={"serviceCampaignPulldownSelect"}
                            value={
                              (editData.editValue as { [key: string]: string })
                                .serviceCampaignPulldownName
                            }
                            onChange={(e) => {
                              const serviceCampaignPulldownName = e.target
                                .value as string;
                              let editValue = editData.editValue as {
                                [key: string]: string | string[];
                              };
                              editValue["serviceCampaignPulldownName"] =
                                serviceCampaignPulldownName;
                              setEditData({
                                ...editData,
                                editValue,
                              });
                            }}
                            sx={{
                              height: "30px",
                              textAlign: "end",
                              fontSize: "14px",
                            }}
                          >
                            {selectServiseInfo.service_campaign_pulldown_data.map(
                              (service, plan_i) => {
                                return (
                                  <MenuItem
                                    key={
                                      "tableColumnKomokuCampaignPulldown" +
                                      plan_i
                                    }
                                    value={service.service_name}
                                    sx={{
                                      fontSize: "14px",
                                      height:
                                        service.service_name === ""
                                          ? "14px"
                                          : "24px",
                                      minHeight: "auto",
                                    }}
                                  >
                                    {service.service_name}
                                  </MenuItem>
                                );
                              },
                            )}
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                  ) : null}
                  {selectServiseInfo.service_campaign_checkbox_data.length >
                  0 ? (
                    <Box key="contractServiceContent">
                      <Box className="serch-label">
                        {selectServiseInfo.service_campaign_pulldown_data
                          .length > 0
                          ? "キャンペーン2"
                          : "キャンペーン"}
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          marginTop: "10px",
                          marginBottom: "20px",
                          marginLeft: "5px",
                          width: "calc(100% - 10px)",
                        }}
                      >
                        {selectServiseInfo.service_campaign_checkbox_data.map(
                          (service) => {
                            return (
                              <Box
                                className="serch-label"
                                sx={{ marginRight: "25px" }}
                              >
                                <Checkbox
                                  checked={
                                    (
                                      editData.editValue as {
                                        [key: string]: string[];
                                      }
                                    ).serviceCampaignCheckboxName.findIndex(
                                      (serviceName) =>
                                        serviceName === service.service_name,
                                    ) > -1
                                  }
                                  onClick={() => {
                                    let serviceCampaignCheckboxName = (
                                      editData.editValue as {
                                        [key: string]: string[];
                                      }
                                    ).serviceCampaignCheckboxName.concat();

                                    if (
                                      (
                                        editData.editValue as {
                                          [key: string]: string[];
                                        }
                                      ).serviceCampaignCheckboxName.findIndex(
                                        (serviceName) =>
                                          serviceName === service.service_name,
                                      ) > -1
                                    ) {
                                      serviceCampaignCheckboxName =
                                        serviceCampaignCheckboxName.filter(
                                          (serviceName) =>
                                            serviceName !==
                                            service.service_name,
                                        );
                                    } else {
                                      serviceCampaignCheckboxName.push(
                                        service.service_name,
                                      );
                                    }
                                    let editValue = editData.editValue as {
                                      [key: string]: string | string[];
                                    };
                                    editValue["serviceCampaignCheckboxName"] =
                                      serviceCampaignCheckboxName;
                                    setEditData({
                                      ...editData,
                                      editValue,
                                    });
                                  }}
                                  sx={{
                                    "& .MuiSvgIcon-root": { fontSize: 16 },
                                    marginTop: "-5px",
                                  }}
                                />
                                {service.service_name}
                              </Box>
                            );
                          },
                        )}
                      </Box>
                    </Box>
                  ) : null}
                </Box>
              ) : editData.editType === "toss_up_info" ? (
                <Box
                  key="shozai1"
                  sx={{
                    maxHeight:
                      windowWidth > 385 ? "calc(70vh - 100px)" : undefined,
                    overflowY: windowWidth > 385 ? "auto" : undefined,
                  }}
                >
                  <Box key="shozaiClick">
                    {selectTossUpInfo.tossUpCategoryNameList.map(
                      (categoryName, category_i) => {
                        function categoryDisabled(category_id: number) {
                          let categoryDisabled = false;
                          selectTossUpInfo.tossUpProductNameList.map(
                            (productName) => {
                              if (
                                (
                                  editData?.editValue as {
                                    [key: string]: string[];
                                  }
                                ).product_name_list.includes(
                                  productName.product_name,
                                ) &&
                                category_id === productName.category_id
                              ) {
                                categoryDisabled = true;
                              }
                            },
                          );
                          return categoryDisabled;
                        }
                        return (
                          <>
                            <Box
                              key={"category_name_" + category_i}
                              className="serch-label"
                              sx={{ marginRight: "25px", marginTop: "15px" }}
                            >
                              <Checkbox
                                checked={(
                                  editData?.editValue as {
                                    [key: string]: string[];
                                  }
                                ).category_id_list.includes(
                                  String(categoryName.category_id),
                                )}
                                disabled={
                                  categoryDisabled(categoryName.category_id)
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  let _category_id_list = (
                                    editData?.editValue as {
                                      [key: string]: string[];
                                    }
                                  ).category_id_list.concat();
                                  let _product_name_list = (
                                    editData?.editValue as {
                                      [key: string]: string[];
                                    }
                                  ).product_name_list.concat();
                                  if (
                                    (
                                      editData?.editValue as {
                                        [key: string]: string[];
                                      }
                                    ).category_id_list.includes(
                                      String(categoryName.category_id),
                                    )
                                  ) {
                                    _category_id_list =
                                      _category_id_list.filter(
                                        (category_id) =>
                                          category_id !==
                                          String(categoryName.category_id),
                                      );
                                  } else {
                                    _category_id_list.push(
                                      String(categoryName.category_id),
                                    );
                                    selectTossUpInfo.tossUpProductNameList.map(
                                      (tossUpProduct) => {
                                        if (
                                          tossUpProduct.category_id ===
                                          categoryName.category_id
                                        ) {
                                          _product_name_list.push(
                                            tossUpProduct.product_name,
                                          );
                                        }
                                      },
                                    );
                                  }
                                  let editValue = editData.editValue as {
                                    [key: string]: string | string[];
                                  };
                                  editValue["category_id_list"] =
                                    _category_id_list;
                                  editValue["product_name_list"] =
                                    _product_name_list;
                                  setEditData({
                                    ...editData,
                                    editValue,
                                  });
                                }}
                                sx={{
                                  "& .MuiSvgIcon-root": { fontSize: 16 },
                                  marginTop: "-2px",
                                }}
                              />
                              {categoryName.category_name}
                            </Box>
                            {selectTossUpInfo.tossUpProductNameList.map(
                              (productName, product_i) => {
                                if (
                                  categoryName.category_name ===
                                  productName.category_name
                                ) {
                                  return (
                                    <Box
                                      key={
                                        "category_product_name_" +
                                        category_i +
                                        "_" +
                                        product_i
                                      }
                                      className="serch-label"
                                      sx={{ marginRight: "25px" }}
                                    >
                                      <Checkbox
                                        checked={(
                                          editData?.editValue as {
                                            [key: string]: string[];
                                          }
                                        ).product_name_list.includes(
                                          productName.product_name,
                                        )}
                                        onClick={() => {
                                          let _category_id_list = (
                                            editData?.editValue as {
                                              [key: string]: string[];
                                            }
                                          ).category_id_list.concat();
                                          let _product_name_list = (
                                            editData?.editValue as {
                                              [key: string]: string[];
                                            }
                                          ).product_name_list.concat();
                                          if (
                                            (
                                              editData?.editValue as {
                                                [key: string]: string[];
                                              }
                                            ).product_name_list.includes(
                                              productName.product_name,
                                            )
                                          ) {
                                            _product_name_list =
                                              _product_name_list.filter(
                                                (product_name) =>
                                                  product_name !==
                                                  productName.product_name,
                                              );
                                          } else {
                                            _product_name_list.push(
                                              productName.product_name,
                                            );
                                            if (
                                              !(
                                                editData?.editValue as {
                                                  [key: string]: string[];
                                                }
                                              ).category_id_list.includes(
                                                String(
                                                  categoryName.category_id,
                                                ),
                                              )
                                            ) {
                                              _category_id_list.push(
                                                String(
                                                  categoryName.category_id,
                                                ),
                                              );
                                            }
                                          }
                                          let editValue =
                                            editData.editValue as {
                                              [key: string]: string | string[];
                                            };
                                          editValue["category_id_list"] =
                                            _category_id_list;
                                          editValue["product_name_list"] =
                                            _product_name_list;
                                          setEditData({
                                            ...editData,
                                            editValue,
                                          });
                                        }}
                                        sx={{
                                          "& .MuiSvgIcon-root": {
                                            fontSize: 16,
                                          },
                                          marginTop: "-2px",
                                          marginLeft: "20px",
                                        }}
                                      />
                                      {productName.product_name}
                                    </Box>
                                  );
                                }
                              },
                            )}
                          </>
                        );
                      },
                    )}
                  </Box>
                </Box>
              ) : (
                <Box data-testid={`edit-modal-field-${editData.key}`}>
                  <CustomTextField
                    disabled
                    id="textFieldId"
                    label="変更前"
                    value={
                      (editData.editType === "list" ||
                        editData.editType === "text" ||
                        editData.editType === "multitext" ||
                        editData.editType === "column_text" ||
                        editData.editType === "column_select_one" ||
                        editData.editType === "column_select_multiple" ||
                        editData.editType === "column_date") &&
                      (typeof editData.value === "string" ||
                        typeof editData.value === "number")
                        ? editData.value
                        : (editData.editType === "outside_site_logo" ||
                              editData.editType === "outside_site_favicon" ||
                              editData.editType === "site_pdf_path") &&
                            (typeof editData.value === "string" ||
                              typeof editData.value === "number")
                          ? editData.value.split("/").pop()
                          : (editData.editType === "customer_text" ||
                                editData.editType === "customer_multitext" ||
                                editData.editType === "customer_select_one" ||
                                editData.editType === "customer_date") &&
                              typeof editData.value !== "string"
                            ? editData.value[editData.key]
                            : editData.editType === "customer_picture" &&
                                typeof editData.value !== "string" &&
                                (editData.value[editData.key] as string)
                              ? (editData.value[editData.key] as string)
                                  .split("/")
                                  .pop()
                              : editData.editType ===
                                    "customer_select_multiple" &&
                                  typeof editData.key === "string" &&
                                  ((
                                    editData.value as {
                                      [key: string]: string | string[];
                                    }
                                  )[editData.key] as string[])
                                ? (
                                    (
                                      editData.value as {
                                        [key: string]: string | string[];
                                      }
                                    )[editData.key] as string[]
                                  ).join("、")
                                : ""
                    }
                    size="small"
                    sx={{ width: "calc(100% - 10px)", margin: "10px 5px" }}
                    multiline={
                      editData.editType === "multitext" ||
                      editData.editType === "customer_multitext"
                    }
                    rows={
                      editData.editType === "multitext" ||
                      editData.editType === "customer_multitext"
                        ? 4
                        : undefined
                    }
                  />
                  <Box sx={{ textAlign: "center" }}>↓</Box>
                  {editData.editType === "text" ||
                  editData.editType === "multitext" ||
                  editData.editType === "column_text" ||
                  editData.editType === "column_date" ? (
                    <CustomTextField
                      type={
                        editData.editType === "column_date" ? "date" : "text"
                      }
                      id="textFieldId"
                      label="変更後"
                      value={editData.editValue}
                      size="small"
                      sx={{ width: "calc(100% - 10px)", margin: "10px 5px" }}
                      onChange={(e) => {
                        setEditData({
                          ...editData,
                          editValue: e.target.value,
                        });
                      }}
                      multiline={editData.editType === "multitext"}
                      rows={editData.editType === "multitext" ? 4 : undefined}
                    />
                  ) : editData.editType === "list" ? (
                    <FormControl
                      fullWidth
                      sx={{
                        marginTop: "10px",
                        marginBottom: "20px",
                        marginLeft: "5px",
                        width: "calc(100% - 10px)",
                      }}
                    >
                      <Autocomplete
                        clearIcon={null}
                        options={autocompleteInputList}
                        value={autocompleteInput}
                        onChange={(event: any, newValue: string | null) => {
                          if (newValue) {
                            setAutocompleteInput(newValue);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            value={autocompleteInput}
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "12px",
                                height: "32px", // ここでフォントサイズを指定
                              },
                            }}
                            {...params}
                          />
                        )}
                      />
                      {editData.key === "login_status" ? (
                        <FormHelperText
                          id="serch-name"
                          sx={{
                            width: "calc(100% - 10px)",
                            textAlign: "right",
                          }}
                        >
                          ※一度「ログイン不可能」としたアカウントを「正常」に変更することはできません
                        </FormHelperText>
                      ) : null}
                      {editData.key === "sns_type" ? (
                        <FormHelperText
                          id="serch-name"
                          sx={{
                            width: "calc(100% - 10px)",
                            textAlign: "right",
                          }}
                        >
                          ※変更後、必要に応じてチャットアプリ連携情報を変更してください
                        </FormHelperText>
                      ) : null}
                      {(editData.key === "sale_account_name" ||
                        editData.key === "toss_up_account_name") &&
                      (loginUser?.authority === "パートナー" ||
                        loginUser?.authority === "営業アカウント") ? (
                        <FormHelperText
                          id="serch-name"
                          sx={{
                            width: "calc(100% - 10px)",
                            textAlign: "right",
                          }}
                        >
                          ※変更後、閲覧権限によっては一覧から消去される点をご留意ください。
                        </FormHelperText>
                      ) : null}
                    </FormControl>
                  ) : editData.editType === "customer_text" ||
                    editData.editType === "customer_multitext" ? (
                    <CustomTextField
                      id="textFieldId"
                      label="変更後"
                      value={
                        typeof editData.editValue === "string" ||
                        Array.isArray(editData.editValue)
                          ? ""
                          : editData.editValue[editData.key]
                      }
                      size="small"
                      sx={{ width: "calc(100% - 10px)", margin: "10px 5px" }}
                      onChange={(e) => {
                        if (
                          editData.half_width_number_flg === 1 &&
                          !/^\d*$/.test(e.target.value)
                        ) {
                          return;
                        }
                        const editValue = editData.editValue as {
                          [key: string]: string | string[];
                        };
                        let customer_info = { ...editValue };
                        customer_info[editData.key] = e.target.value;
                        if (editData.tel_flg === 1) {
                          setEditData({
                            ...editData,
                            editValue: customer_info,
                            editPhoneNumber: e.target.value,
                          });
                        } else if (editData.name_flg === 1) {
                          setEditData({
                            ...editData,
                            editValue: customer_info,
                            editName: e.target.value,
                          });
                        } else if (editData.company_name_flg === 1) {
                          setEditData({
                            ...editData,
                            editValue: customer_info,
                            editCustomerName: e.target.value,
                          });
                        } else {
                          setEditData({
                            ...editData,
                            editValue: customer_info,
                          });
                        }
                      }}
                      multiline={editData.editType === "customer_multitext"}
                      rows={
                        editData.editType === "customer_multitext"
                          ? 4
                          : undefined
                      }
                    />
                  ) : editData.editType === "customer_select_one" ? (
                    <FormControl
                      fullWidth
                      sx={{
                        marginTop: "10px",
                        marginBottom: "20px",
                        marginLeft: "5px",
                        width: "calc(100% - 10px)",
                      }}
                    >
                      <InputLabel id="serch-input-label">変更後</InputLabel>
                      <Select
                        label="変更後"
                        labelId="serch-input-label"
                        id="serch-input"
                        value={
                          typeof editData.editValue === "string" ||
                          Array.isArray(editData.editValue)
                            ? ""
                            : editData.editValue[editData.key]
                        }
                        onChange={(e) => {
                          const editValue = editData.editValue as {
                            [key: string]: string | string[];
                          };
                          let customer_info = { ...editValue };
                          customer_info[editData.key] = e.target.value;
                          setEditData({
                            ...editData,
                            editValue: customer_info,
                          });
                        }}
                        sx={{
                          height: "30px",
                          textAlign: "end",
                          fontSize: "14px",
                        }}
                      >
                        {editData.customerList.map((option, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={option.option_select}
                              sx={{
                                fontSize: "14px",
                                height:
                                  option.option_select === "" ? "14px" : "24px",
                                minHeight: "auto",
                              }}
                            >
                              {option.option_select}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  ) : editData.editType === "customer_select_multiple" ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        marginTop: "10px",
                        marginBottom: "20px",
                        marginLeft: "5px",
                        width: "calc(100% - 10px)",
                      }}
                    >
                      {editData.customerList.map((option, i) => {
                        return (
                          <Box
                            className="serch-label"
                            sx={{ marginRight: "25px" }}
                          >
                            <Checkbox
                              checked={
                                ((
                                  editData.editValue as {
                                    [key: string]: string | string[];
                                  }
                                )[editData.key] as string[])
                                  ? (
                                      (
                                        editData.editValue as {
                                          [key: string]: string | string[];
                                        }
                                      )[editData.key] as string[]
                                    ).findIndex(
                                      (_option_select) =>
                                        _option_select === option.option_select,
                                    ) > -1
                                  : false
                              }
                              onClick={() => {
                                const editValue = editData.editValue as {
                                  [key: string]: string | string[];
                                };
                                let customer_info = { ...editValue };
                                let customer_info_list: string[] = [];
                                if (customer_info[editData.key]) {
                                  customer_info_list = customer_info[
                                    editData.key
                                  ].concat() as string[];
                                }
                                if (
                                  customer_info_list.findIndex(
                                    (_option_select) =>
                                      _option_select === option.option_select,
                                  ) > -1
                                ) {
                                  customer_info_list =
                                    customer_info_list.filter(
                                      (_option_select) =>
                                        _option_select !== option.option_select,
                                    );
                                } else {
                                  customer_info_list.push(option.option_select);
                                }
                                customer_info[editData.key] =
                                  customer_info_list;
                                setEditData({
                                  ...editData,
                                  editValue: customer_info,
                                });
                              }}
                              sx={{
                                "& .MuiSvgIcon-root": { fontSize: 16 },
                                marginTop: "-5px",
                              }}
                            />
                            {option.option_select}
                          </Box>
                        );
                      })}
                    </Box>
                  ) : editData.editType === "customer_date" ? (
                    <CustomTextField
                      id="textFieldId"
                      label="変更後"
                      type="date"
                      value={
                        typeof editData.editValue === "string" ||
                        Array.isArray(editData.editValue)
                          ? "2000-01-01"
                          : editData.editValue[editData.key]
                      }
                      size="small"
                      sx={{ width: "calc(100% - 10px)", margin: "10px 5px" }}
                      onChange={(e) => {
                        if (
                          editData.half_width_number_flg === 1 &&
                          !/^\d*$/.test(e.target.value)
                        ) {
                          return;
                        }
                        const editValue = editData.editValue as {
                          [key: string]: string | string[];
                        };
                        let customer_info = { ...editValue };
                        customer_info[editData.key] = e.target.value;
                        if (editData.tel_flg === 1) {
                          setEditData({
                            ...editData,
                            editValue: customer_info,
                            editPhoneNumber: e.target.value,
                          });
                        } else if (editData.name_flg === 1) {
                          setEditData({
                            ...editData,
                            editValue: customer_info,
                            editName: e.target.value,
                          });
                        } else if (editData.company_name_flg === 1) {
                          setEditData({
                            ...editData,
                            editValue: customer_info,
                            editCustomerName: e.target.value,
                          });
                        } else {
                          setEditData({
                            ...editData,
                            editValue: customer_info,
                          });
                        }
                      }}
                    />
                  ) : editData.editType === "customer_picture" ||
                    editData.editType === "outside_site_logo" ||
                    editData.editType === "outside_site_favicon" ||
                    editData.editType === "site_pdf_path" ? (
                    <input
                      id="textFieldPicture"
                      type="file"
                      onChange={(
                        event_file: React.ChangeEvent<HTMLInputElement>,
                      ) => {
                        if (
                          event_file.target.files &&
                          event_file.target.files.length > 0
                        ) {
                          const file = event_file.target.files[0];
                          setEditData({
                            ...editData,
                            customer_picture: file,
                          });
                        }
                      }}
                    />
                  ) : editData.editType === "column_select_one" ? (
                    <FormControl
                      fullWidth
                      sx={{
                        marginTop: "10px",
                        marginBottom: "20px",
                        marginLeft: "5px",
                        width: "calc(100% - 10px)",
                      }}
                    >
                      <InputLabel id="serch-input-label">変更後</InputLabel>
                      <Select
                        label="変更後"
                        labelId="serch-input-label"
                        id="serch-input"
                        value={editData.editValue}
                        onChange={(e) => {
                          setEditData({
                            ...editData,
                            editValue: e.target.value,
                          });
                        }}
                        sx={{
                          height: "30px",
                          textAlign: "end",
                          fontSize: "14px",
                        }}
                      >
                        {editData.customerList.map((option, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={option.option_select}
                              sx={{
                                fontSize: "14px",
                                height:
                                  option.option_select === "" ? "14px" : "24px",
                                minHeight: "auto",
                              }}
                            >
                              {option.option_select}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  ) : editData.editType === "column_select_multiple" ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        marginTop: "10px",
                        marginBottom: "20px",
                        marginLeft: "5px",
                        width: "calc(100% - 10px)",
                      }}
                    >
                      {editData.customerList.map((option, i) => {
                        return (
                          <Box
                            className="serch-label"
                            sx={{ marginRight: "25px" }}
                          >
                            <Checkbox
                              checked={
                                Array.isArray(editData.editValue) &&
                                editData.editValue.includes(
                                  option.option_select,
                                )
                              }
                              onClick={() => {
                                let editValue = (
                                  editData.editValue as string[]
                                ).concat();
                                if (
                                  Array.isArray(editData.editValue) &&
                                  editData.editValue.includes(
                                    option.option_select,
                                  )
                                ) {
                                  editValue = editValue.filter(
                                    (option_select) =>
                                      option_select !== option.option_select,
                                  );
                                } else {
                                  editValue.push(option.option_select);
                                }
                                setEditData({
                                  ...editData,
                                  editValue: editValue,
                                });
                              }}
                              sx={{
                                "& .MuiSvgIcon-root": { fontSize: 16 },
                                marginTop: "-5px",
                              }}
                            />
                            {option.option_select}
                          </Box>
                        );
                      })}
                    </Box>
                  ) : null}
                </Box>
              )}
              <Box style={{ display: windowWidth > 385 ? "flex" : undefined }}>
                <Box
                  style={{
                    marginTop: "10px",
                    height: "40px",
                    width:
                      windowWidth > 385
                        ? "calc(50% - 5px)"
                        : "calc(100% - 10px)",
                    marginLeft: windowWidth > 385 ? undefined : "5px",
                  }}
                >
                  <Button
                    disabled={
                      editData.editType === "customer_picture" ||
                      editData.editType === "outside_site_logo" ||
                      editData.editType === "outside_site_favicon" ||
                      editData.editType === "site_pdf_path"
                        ? editData.customer_picture === null
                        : editData.value === editData.editValue
                    }
                    variant="contained"
                    style={{
                      height: "40px",
                      width: "100%",
                      textTransform: "none",
                    }}
                    data-testid="edit-modal-save-button"
                    onClick={putEditData}
                  >
                    <Box
                      className="m-plus-rounded-1c-regular"
                      style={{
                        color:
                          editData.editType !== "customer_picture" &&
                          editData.editType !== "outside_site_logo" &&
                          editData.editType !== "outside_site_favicon" &&
                          editData.editType !== "site_pdf_path" &&
                          editData.value === editData.editValue
                            ? "rgb(70 70 70)"
                            : (editData.editType === "customer_picture" ||
                                  editData.editType === "outside_site_logo" ||
                                  editData.editType ===
                                    "outside_site_favicon" ||
                                  editData.editType === "site_pdf_path") &&
                                editData.customer_picture === null
                              ? "rgb(70 70 70)"
                              : undefined,
                      }}
                    >
                      編集
                    </Box>
                    <EditNoteIcon
                      sx={{
                        marginLeft: "6px",
                        color:
                          editData.editType !== "customer_picture" &&
                          editData.editType !== "outside_site_logo" &&
                          editData.editType !== "outside_site_favicon" &&
                          editData.editType !== "site_pdf_path" &&
                          editData.value === editData.editValue
                            ? "rgb(70 70 70)"
                            : (editData.editType === "customer_picture" ||
                                  editData.editType === "outside_site_logo" ||
                                  editData.editType ===
                                    "outside_site_favicon" ||
                                  editData.editType === "site_pdf_path") &&
                                editData.customer_picture === null
                              ? "rgb(70 70 70)"
                              : "white",
                      }}
                      fontSize="medium"
                    />
                  </Button>
                </Box>
                <Box
                  style={{
                    marginTop: "10px",
                    height: "40px",
                    width:
                      windowWidth > 385
                        ? "calc(50% - 5px)"
                        : "calc(100% - 10px)",
                    marginLeft: windowWidth > 385 ? "10px" : "5px",
                  }}
                >
                  <Button
                    variant="contained"
                    style={{
                      height: "40px",
                      width: "100%",
                      textTransform: "none",
                    }}
                    data-testid="edit-modal-cancel-button"
                    onClick={swCloseModal}
                  >
                    <Box className="m-plus-rounded-1c-regular">キャンセル</Box>
                  </Button>
                </Box>
              </Box>
            </>
          ) : editData.status === "success" ? (
            <>
              <Box className="shippori-antique-regular">
                値の編集に成功しました。
              </Box>
              <Box>
                <Button
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={swCloseModal}
                >
                  <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                </Button>
              </Box>
            </>
          ) : editData.status === "failed" ? (
            <>
              <Box className="shippori-antique-regular">
                データの登録に失敗しました。
                <br />
                データの形式が異なる可能性があります。
              </Box>
              <Box>
                <Button
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={() =>
                    setEditData({
                      ...editData,
                      status: "before",
                    })
                  }
                >
                  <Box className="m-plus-rounded-1c-regular">OK</Box>
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Box className="shippori-antique-regular">{editData.status}</Box>
              <Box>
                <Button
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={() =>
                    setEditData({
                      ...editData,
                      status: "before",
                    })
                  }
                >
                  <Box className="m-plus-rounded-1c-regular">OK</Box>
                </Button>
              </Box>
            </>
          )}
        </Typography>
      </Box>
    </Modal>
  ) : null;
}
